import type {AllowedComponentProps, FunctionalComponent, VNodeProps} from "vue";
import type {Component as VueComponent} from "@vue/runtime-core";

type ComponentProps<C extends VueComponent> = C extends new (
  ...args: any
) => any
  ? Omit<
      InstanceType<C>["$props"],
      keyof VNodeProps | keyof AllowedComponentProps
    >
  : never;

export const createFunctionalComponent = <C extends VueComponent>(
  component: C,
  props: ComponentProps<C>,
) => {
  const _component: FunctionalComponent<ComponentProps<C>> = (
    _props,
    {slots, attrs},
  ) => {
    const mergedProps = {
      ..._props,
      ...props,
      ...attrs,
    };
    return h(component, mergedProps, slots);
  };
  return _component;
};
